import React, { useState } from 'react';
import { Wallet, Coins, ChartLineUp } from 'phosphor-react';
import { useFetch } from '_api';
import { formatVND, toYmd } from '_helpers';
import { PageHeader, Bezel, StatCard, PeriodPicker, MotionReveal } from '_ui';

const now = new Date();

export function DoanhThu() {
    const [view, setView] = useState({ mode: 'month', date: toYmd(now), period: { month: now.getMonth() + 1, year: now.getFullYear() } });
    const query = view.mode === 'day' ? `date=${view.date}` : `month=${view.period.month}&year=${view.period.year}`;
    const { data, loading } = useFetch(`/api/payouts?${query}`);

    // businessTotals covers every paid transaction in the period, including sales a manager
    // logged themselves — those count as revenue too, just with no commission attached.
    const totals = data?.businessTotals || { totalRevenue: 0, totalCommission: 0, count: 0 };
    const totalRevenue = totals.totalRevenue;
    const totalCommission = totals.totalCommission;
    const net = totalRevenue - totalCommission;

    return (
        <div className="space-y-10">
            <PageHeader
                eyebrow="Quản lý"
                title="Doanh thu"
                description={view.mode === 'day' ? 'Tổng doanh thu và hoa hồng trong ngày, trên các hoá đơn đã thanh toán.' : 'Tổng doanh thu và hoa hồng trong tháng, trên các hoá đơn đã thanh toán.'}
                actions={<PeriodPicker value={view} onChange={setView} />}
            />

            <div className="grid gap-5 sm:grid-cols-3">
                <MotionReveal><StatCard label="Doanh thu" value={loading ? '—' : formatVND(totalRevenue)} icon={Wallet} /></MotionReveal>
                <MotionReveal delay={0.05}><StatCard label="Hoa hồng" value={loading ? '—' : formatVND(totalCommission)} icon={Coins} accent="sage" /></MotionReveal>
                <MotionReveal delay={0.1}><StatCard label="Doanh thu sau hoa hồng" value={loading ? '—' : formatVND(net)} icon={ChartLineUp} /></MotionReveal>
            </div>

            <Bezel className="p-6 sm:p-8">
                <p className="text-sm text-espresso-soft/80">
                    {view.mode === 'day'
                        ? `Ngày ${view.date.split('-').reverse().join('/')}: `
                        : `Tháng ${view.period.month}/${view.period.year}: `}
                    doanh thu <span className="font-semibold text-espresso">{formatVND(totalRevenue)}</span>, trừ hoa hồng{' '}
                    <span className="font-semibold text-sage-deep">{formatVND(totalCommission)}</span>, còn lại{' '}
                    <span className="font-semibold text-espresso">{formatVND(net)}</span>.
                </p>
            </Bezel>
        </div>
    );
}
